import React from "react";
import "./Loader.css";
import shoes from "../../../icons/shoes.svg";

const Loader = () => (
  <div className="loader-container">
    <div className="overlay" />
    <div className="shoes-first">
      <img alt="loader-shoes" src={shoes} />
    </div>
    <div className="shoes-second">
      <img alt="loader-shoes" src={shoes} />
    </div>
  </div>
);

export default Loader;



// WEBPACK FOOTER //
// ./src/containers/App/Loader/Loader.jsx